import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';

const FONT_SIZE = 7.7;
const DEFAULT_INPUT_WIDTH = 180;

function TextFieldAutoWidth(props) {
    const [inputWidth, setInputWidth] = useState(DEFAULT_INPUT_WIDTH);
    const InputProps = props?.InputProps || {};
    const value = props?.inputProps?.value || '';
    const InputPropsStyle = props?.InputProps?.style || {};
    useEffect(() => {
        if (typeof value !== 'string') {
            setInputWidth(DEFAULT_INPUT_WIDTH);
            return;
        }
        if (value.length * FONT_SIZE > DEFAULT_INPUT_WIDTH) {
            setInputWidth((value.length + 1) * FONT_SIZE);
        } else {
            setInputWidth(DEFAULT_INPUT_WIDTH);
        }
    }, [value]);

    const { style, ...rest } = InputProps;

    return (
        <TextField
            {...props}
            InputProps={{
                style: {
                    width: `${inputWidth}px`,
                    ...InputPropsStyle
                },
                ...rest
            }}
        />
    );
}

export default TextFieldAutoWidth;
